exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EventsRow-19cc42a6{font-size:14px;line-height:20px;padding:15px;display:flex;flex-direction:row;text-align:left;color:#424242;border-bottom:1px solid #E0E0E0}.left-c6d7eb92{flex:1 1 auto}.right-d071a7c4{flex:0 1 100px;height:100px}.timespan-1e013772{font-weight:500;color:#616161}.name-ae1d00ca{font-size:18px;line-height:22px;font-weight:500}.name-ae1d00ca a{text-decoration:none}.icon-6d65da55{color:#727272}.emptyList-5cfd196d{font-size:18px;line-height:22px;color:#616161;margin:3em 1em;text-align:center}\n", ""]);

// Exports
exports.locals = {
	"EventsRow": "EventsRow-19cc42a6",
	"left": "left-c6d7eb92",
	"right": "right-d071a7c4",
	"timespan": "timespan-1e013772",
	"name": "name-ae1d00ca",
	"icon": "icon-6d65da55",
	"emptyList": "emptyList-5cfd196d"
};